// src/http.js
import axios from 'axios';

const http = axios.create({
  baseURL: 'https://www.ltt-lab.com.cn/api', // 你的基础URL
  timeout: 10000, // 请求超时时间
});

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么，例如设置token
  const token = localStorage.getItem('your-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  if (error.response && error.response.status === 401) {
    // 例如，处理401未授权错误，可能需要重新登录等操作
    console.error('Unauthorized, please login again.');
  }
  return Promise.reject(error);
});

export default http;


// WEBPACK FOOTER //
// ./src/utils/request.js